const BASE_PATH = import.meta.env.BASE_URL || '/'

// The hub frontend and API are hosted under the same /hub namespace in tmsoft.
// En desarrollo es relativa a propósito: la petición pasa por el proxy de Vite,
// que reescribe igual que Traefik. La forma `/hub/api` es la misma en los dos
// entornos; la ruta real del backend (`/api/hub`) solo la conoce quien reescribe.
const API_URL = import.meta.env['VITE_API_URL'] || (import.meta.env.PROD
  ? `${window.location.origin}/hub/api`
  : '/hub/api')

const BASE_URL = import.meta.env.PROD
  ? `${window.location.origin}${BASE_PATH}`.replace(/\/+/g, '/').replace(':/', '://')
  : `${window.location.origin}`

export { API_URL, BASE_URL }
